<template lang="pug">
.map-app__content-section
    ul.map-app__highlights-list
        li(
            v-for="item in highlightsArr"
        )
            router-link(
                href="#"
                :to="`/highlight/${item.link}`"
                @click="clickHandler"
            ) {{ item.name }}

</template>

<script>
export default {
    name:'highlight',
    props: ['data'],
    data() {
        return {
            highlightsArr: []
        }
    },
    mounted() {
        this.highlightsArr = this.data.highlightsArr
        this.$root.$emit('tab-page-active', 'highlights')
    },
    methods: {
        clickHandler(e) {
            e.preventDefault()
            thi.$root.$emit('child-route-updated')
        }
    },
}
</script>

<style lang="scss">
@import "../scss/variables";

.map-app__content-section {
    position: relative;
    width: 100%;
    opacity: 1;
    background: $white;
}
.map-app__highlights-list {
	counter-reset: count;

    &__highlights-list {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    li {
        position: relative;
        display: flex;
        border-top: 1px solid $grey2;
        padding: 1rem;
        width: 100%;
        counter-increment: count;
        align-items: center;

        a {
            position: absolute;
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 0 3rem 0 3.5rem;
            left: 0;
            top: 0;

            &:hover {

                &::after {
                    margin-right: 1rem;
                }
            }

            &::after {
                font-family: 'icomoon';
                position: absolute;
                width: 24px;
                height: 24px;
                margin-right: 1.25rem;
                right: 0;
                color: $black;
                content: "\e906";
                transition: margin 0.25s ease-in-out;
            }
        }

        &::before {
            content: counter(count);
            color: $white;
            border-radius: 50%;
            background-color: $red;
            width: 24px;
            height: 24px;
            font-weight: bold;
            margin-right: 1em;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &:last-child {
            border-bottom: 1px solid $grey2;
        }
    }
}
</style>